import { Amount } from './amount';
import { OrderStatusEnum } from './OrderStatus';

export enum InstructionTypeValueEnum {
  'ORDER_AT_BEST' = 'ORDER_AT_BEST',
  'LIMIT_ORDER' = 'LIMIT_ORDER',
  'AT_OPENING' = 'AT_OPENING',
  'DISCRETIONARY' = 'DISCRETIONARY',
  'SUBSCRIPTION' = 'SUBSCRIPTION',
  'STOP' = 'STOP',
  'TRAIL' = 'TRAIL',
  'FUND' = 'FUND',
  'DIRECT' = 'DIRECT',
  'CONFIRMATION' = 'CONFIRMATION',
  'GOOD_TIL_CANCELLED' = 'GOOD_TIL_CANCELLED',
  'MARKET_ON_CLOSE' = 'MARKET_ON_CLOSE',
  'VOLUME_WEIGHTED_AVERAGE_PRICE' = 'VOLUME_WEIGHTED_AVERAGE_PRICE',
  'TIME_WEIGHTED_AVERAGE_PRICE' = 'TIME_WEIGHTED_AVERAGE_PRICE',
  'STRICT_LIMIT' = 'TIME_WEIGHTED_AVERAGE_PRICE'
}

export enum OrderSideEnum {
  'BUY' = 'BUY',
  'SELL' = 'SELL'
}

export enum LimitTypeValueEnum {
  'GOOD_DAY_ONLY' = 'GOOD_DAY_ONLY',
  'GOOD_TILL_CANCEL' = 'GOOD_TILL_CANCEL',
  'GOOD_TILL_DATE' = 'GOOD_TILL_DATE'
}

export enum ApiOrderCreationStatusEnum {
  'PENDING_AUTHORIZATION' = 'PENDING_AUTHORIZATION',
  'WAITING_AUTHORIZATION_CONFIRMATION' = 'WAITING_AUTHORIZATION_CONFIRMATION',
  'AUTHORIZATION_SUCCEEDED' = 'AUTHORIZATION_SUCCEEDED',
  'AUTHORIZATION_FAILED' = 'AUTHORIZATION_FAILED',
  'AUTHORIZATION_EXPIRED' = 'AUTHORIZATION_EXPIRED'
}

export interface InvestmentOrder {
  id?: number;
  generalOrderId?: number;
  accountId?: string;
  securityId?: number;
  orderDate?: string;
  executionDate?: string;
  quantity?: number;
  orderPrice?: number;
  exchangeRate?: number;
  grossAmount?: Amount;
  netAmount?: Amount;
  limitDate?: string;
  instructionTypeValue?: InstructionTypeValueEnum;
  limitTypeValue?: LimitTypeValueEnum;
  limitPrice?: number;
  orderSide?: OrderSideEnum;
  orderStatus?: OrderStatusEnum;
  apiOrderCreationStatus?: ApiOrderCreationStatusEnum;
  identification?: string;
}

export interface InvestmentOrderRequest {
  accountId?: string;
  orderSide?: OrderSideEnum;
  quantity?: number;
  securityId?: number;
  limitDate?: string;
  instructionTypeValue?: InstructionTypeValueEnum;
  limitTypeValue?: LimitTypeValueEnum;
  limitPrice?: number;
}

export interface InvestmentOrderAuthorizationResponse {
  apiOrderCreationStatus: ApiOrderCreationStatusEnum;
  orderId: number;
}

export enum OrderStatusFilterEnum {
  ALL = 'ALL',
  PENDING = 'PENDING',
  DELETED = 'DELETED',
  EXECUTED = 'EXECUTED',
  EXPIRED = 'EXPIRED'
}
